<template>
  <!-- 新增工单 -->
  <el-dialog
    class="add-dialog"
    title="新增工单"
    width="65%"
    top="60px"
    :fullscreen="dialogFull"
    :visible.sync="dialogOrderCreateBoxVisible"
    append-to-body
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template slot="title">
      <div class="avue-crud__dialog__header">
        <span class="el-dialog__title"> 新增工单 </span>
        <i
          class="el-icon-full-screen"
          style="margin-right: 20px; position: relative; top: -1px"
          @click="dialogFull = !dialogFull"
        ></i>
      </div>
    </template>
    <div style="max-height: calc(100vh - 320px); overflow-y: scroll; overflow-x: hidden">
      <!-- 通用表单项PYC -->
      <el-form
        size="small"
        v-if="dialogOrderCreateBoxVisible"
        label-width="150px"
        ref="addForm"
        id="addForm"
        :rules="addFormRules"
        :model="addForm"
        inline
      >
        <el-row>
          <el-col span="8">
            <div class="reset-form-item-content">
              <el-form-item label="来源" prop="source" style="display: flex">
                <el-select v-model="addForm.source" placeholder="请选择 来源" style="width: 100%">
                  <el-option
                    v-for="(item, index) in orderRequireSourceList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col span="8">
            <div class="reset-form-item-content">
              <el-form-item label="项目" prop="projectId" style="display: flex">
                <el-select
                  v-model="addForm.projectId"
                  @change="changeHandler_"
                  placeholder="请选择 项目"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in projectIdList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col span="8">
            <div class="reset-form-item-content">
              <el-form-item label="服务类型" prop="moduleType" style="display: flex">
                <el-select
                  style="width: 100%"
                  placeholder="请选择 服务类型"
                  v-model="addForm.moduleType"
                  @change="orderModuleTpyeChange"
                >
                  <el-option
                    v-for="(item, index) in moduleTypeList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col span="8">
            <div class="reset-form-item-content">
              <el-form-item label="子类型名称" prop="subModuleId" style="display: flex">
                <el-select
                  style="width: 100%"
                  placeholder="请选择 子类型名称"
                  v-model="addForm.subModuleId"
                  @change="orderSubModuleIdChange"
                >
                  <el-option
                    v-for="(item, index) in subModuleList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col span="8" v-if="addForm.moduleType !== 6">
            <div class="reset-form-item-content">
              <el-form-item label="服务地点" prop="areaId" style="display: flex">
                <el-select
                  style="width: 100%"
                  v-model="addForm.areaId"
                  :value="addForm.areaId"
                  placeholder="请选择 服务地点"
                  clearable
                  ref="addConnectSelect"
                >
                  <el-option :value="addForm.areaId" show-all-levels :label="addForm.areaName">
                    <el-tree
                      node-key="id"
                      :data="treeFormAreaData"
                      :props="treeProps"
                      :load="editAreaLazyLoadTree"
                      lazy
                      @node-click="editAreaNodeTreeClick_"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col span="8" v-if="addForm.moduleType !== 6">
            <div class="reset-form-item-content">
              <el-form-item label="需求部门" prop="requireDeptName" style="display: flex">
                <el-input
                  style="width: 100%"
                  placeholder="请选择 需求部门"
                  v-model="addForm.requireDeptName"
                  readonly
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col span="8" v-if="addForm.moduleType === 6">
            <div class="reset-form-item-content">
              <el-form-item label="需求部门" prop="deptId" style="display: flex">
                <el-select
                  v-model="addForm.deptId"
                  placeholder="请选择 需求部门"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in deptList_"
                    :key="index"
                    :label="item.deptName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col span="8" v-if="addForm.moduleType === 6">
            <div class="reset-form-item-content">
              <el-form-item label="需求人" prop="requireMainId" style="display: flex">
                <UserEditBox4
                  @peopleChange="peopleChange"
                  v-model="addForm.requireMainId"
                  placeholder="请选择 需求人"
                  :remainUserListInside.sync="remainUserList"
                  :projectId="addForm.projectId"
                  :single="true"
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col span="8" v-if="addForm.moduleType !== 6">
            <div class="reset-form-item-content">
              <el-form-item label="需求人" prop="requireMainId" style="display: flex">
                <UserEditBox4
                  v-model="addForm.requireMainId"
                  placeholder="请选择 需求人"
                  :remainUserListInside.sync="remainUserList"
                  :projectId="addForm.projectId"
                  :disabled="pageMode == 0"
                  :single="true"
                />
              </el-form-item>
            </div>
          </el-col>

          <el-col span="8" v-if="addForm.moduleType === 6">
            <div class="reset-form-item-content">
              <!-- 设备巡检不需要期望到场时间 -->
              <el-form-item prop="useType" label="用途" style="display: flex">
                <el-select v-model="addForm.useType" placeholder="请选择 用途" style="width: 100%">
                  <el-option
                    v-for="(item, index) in useTypeList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col span="8">
            <div class="reset-form-item-content">
              <el-form-item label="紧急程度" prop="urgentLevel" style="display: flex">
                <el-select
                  v-model="addForm.urgentLevel"
                  placeholder="请选择 紧急程度"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in urgentLevelList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
                <el-input v-model="addForm.requireManName" style="display: none"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col span="8">
            <div class="reset-form-item-content">
              <!-- 设备巡检不需要期望到场时间 -->
              <el-form-item
                v-if="choosenModuleName !== 'EquipmentInspection'"
                prop="expectStartTime"
                label="期望到场时间"
                style="display: flex"
              >
                <el-date-picker
                  style="width: 100%"
                  v-model="addForm.expectStartTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <div class="reset-form-item-content">
            <el-form-item
              label-width="122px"
              label="需求描述"
              prop="description"
              style="display: flex"
            >
              <el-input
                type="textarea"
                placeholder="请选择 需求描述"
                v-model="addForm.description"
                style="height: 5rem"
                maxlength="100"
              >
              </el-input>
              <remarkModel
                :remark.sync="addForm.description"
                ref="addFormRemarkModel"
              ></remarkModel>
            </el-form-item>
          </div>
        </el-row>
        <el-row>
          <el-form-item label="附件上传" label-width="110px">
            <VUpload :fileList.sync="fileList" />
          </el-form-item>
        </el-row>
      </el-form>
      <!-- 特有表单项start -->
      <component
        ref="addFormExtend"
        :is="choosenModuleName"
        :projectId="addForm.projectId"
        :addFormExtend="addFormExtend"
      ></component>
    </div>
    <!-- 特有表单项end -->
    <div slot="footer">
      <el-button
        type="primary"
        @click="submitOrderCreateForm"
        icon="el-icon-check"
        size="small"
        :loading="submitLoading"
      >
        保 存
      </el-button>
      <el-button @click="handleClose" size="small" icon="el-icon-close"> 取 消 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import UserEditBox4 from '@/views/components/user-edit-box4';
import VUpload from '@/views/components/v-upload';
import {
  settingPositionflag,
  getDictionary,
  modulesSetting2,
} from '@/api/crmedical/order/order-add';
import { getOrderUrgentLevel } from '@/api/crmedical/order/order';
import { getSubModuleListByOrderFlag } from '@/api/crmedical/order/order';
import { lazyTree } from '@/api/crmedical/project/area';
import {
  getprojectList,
  getDictData,
  lazyAreaTree,
  getDeptDetailByAreaId,
  getDeptUserListByDeptId,
  getRemarkList,
} from '@/api/crmedical/order/order-list/order-list';
import { fieldDetail } from '@/api/v4ward/ordersetting/setting/selfForm';
import { getDeptNameByUserId } from '@/api/crmedical/car/car-record/index';
import { vLongitude, vLatitude } from '@/util/validate';
import { mapGetters } from 'vuex';
import { createOrderApi } from '@/api/call-system/index';

export default {
  name: 'AddOrder',
  components: {
    UserEditBox4,
    VUpload,
  },
  data() {
    return {
      dialogOrderCreateBoxVisible: false,
      dialogFull: false,
      addForm: {},
      addFormRules: {
        source: [
          {
            required: true,
            message: '请选择来源',
            trigger: 'change',
          },
        ],
        projectId: [
          {
            required: true,
            message: '请选择项目',
            trigger: 'change',
          },
        ],
        moduleType: [
          {
            required: true,
            message: '请选择服务类型',
            trigger: 'change',
          },
        ],
        areaId: [
          {
            required: true,
            message: '请选择服务地点',
            trigger: 'change',
          },
        ],
        requireMainId: [
          {
            required: true,
            message: '请选择需求人',
            trigger: 'change',
          },
        ],
        urgentLevel: [
          {
            required: true,
            message: '请选择紧急程度',
            trigger: 'bulr',
          },
        ],
        useType: [
          {
            required: true,
            message: '请选择用途',
            trigger: 'bulr',
          },
        ],
        expectStartTime: [
          {
            required: true,
            message: '请选择期望到场时间',
            trigger: 'change',
          },
        ],
        description: [
          {
            required: true,
            message: '请输入需求描述',
            trigger: 'change',
          },
        ],
        positionLatitude: [
          {
            required: true,
            message: '请输入纬度',
            trigger: 'change',
          },
          {
            validator: vLatitude(),
            trigger: 'change',
          },
        ],
        positionLongitude: [
          {
            required: true,
            message: '请输入经度',
            trigger: 'change',
          },
          {
            validator: vLongitude(),
            trigger: 'change',
          },
        ],
      },
      addFormExtend: {},
      orderRequireSourceList: [], // 来源下拉框
      projectIdList: [], // 项目下拉框
      moduleTypeList: [], // 服务类型下拉框
      moduleTypeKey: '', // 服务类型
      subModuleList: [], // 子类型下拉框
      treeFormAreaData: [], // 服务地点树状数据
      treeProps: {
        label: 'name',
        value: 'id',
        children: 'zones',
        isLeaf: 'hasChildren',
        objectType: 'id',
        objectTypeName: 'name',
      },
      deptList_: [], // 需求部门下拉框
      remainUserList: [], // 需求人
      useTypeList: [], // 用途下拉框
      urgentLevelList: [], // 紧急程度下拉框
      fileList: [], // 附件列表
      formImgRequireFlag: false, // 附件是否为必填字段
      choosenModuleName: '',
      deviceIdReportRepair: '',
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    getprojectList().then(({ data }) => {
      this.projectIdList = data;
    });
    getDictData('car_use_type').then((res) => {
      this.useTypeList = res.data;
    });
    getDictData('order_urgent_level').then((res) => {
      this.urgentLevelList = res.data;
    });
  },
  methods: {
    showDialog() {
      this.projectId = '';
      this.addForm = {};
      this.addForm.projectId = '';
      this.fileList = [];
      this.addFormExtend = {};
      this.choosenModuleName = '';
      this.remainUserList = [];
      // 需求来源
      if (this.deviceIdReportRepair) {
        this.addForm.moduleJson = {
          deviceId: this.deviceIdReportRepair,
        };
      }
      this.subModuleList = [];
      this.dialogOrderCreateBoxVisible = true;
      getDictionary({
        code: 'order_require_source',
      }).then((res) => {
        this.orderRequireSourceList = [];
        res.data.forEach((ele, index) => {
          if (ele.dictValue === '电话' || ele.dictValue === '现场') {
            this.orderRequireSourceList.push(ele);
          }
        });
        getOrderUrgentLevel().then((res) => {
          this.urgentLevelList = res.data;
          this.addForm.urgentLevel = this.urgentLevelList[0].dictKey;
          let self = this;
          this.requireUserList = [
            {
              value: self.userInfo.user_id,
              label: self.userInfo.nick_name,
              id: self.userInfo.user_id,
              realNameAndPhone: self.userInfo.nick_name,
            },
          ];
          setTimeout(() => {
            this.requireUserList.forEach((ele, index) => {
              if (ele.id === this.userInfo.user_id) {
                this.addForm.requireMainId = this.userInfo.user_id;
                this.addForm = Object.assign({}, this.addForm, {
                  requireMainId: this.userInfo.user_id,
                  requireManName: ele.realName,
                });
              }
            });
          });
        });
      });
    },
    /* 新增工单 */
    submitOrderCreateForm() {
      this.submitLoading = true;
      if (this.formImgRequireFlag) {
        if (this.fileList.length == 0) {
          this.$message.error('附件上传不能为空');
          this.submitLoading = false;
          return;
        }
      }
      if (this.subModuleList && JSON.stringify(this.subModuleList) === '{}') {
      } else if (!this.subModuleList) {
      } else {
        if (!this.addForm.subModuleId) {
          this.$message.error("请选择'子类型名称'!");
          this.submitLoading = false;
          return;
        }
      }

      this.$refs.addForm.validate((valiForm) => {
        if (!valiForm) {
          this.submitLoading = false;
          return false;
        }
        // 校验拓展表
        let deviceId = '';
        let webCreate = 0;
        if (this.choosenModuleName === 'EquipmentMaintenance') {
          deviceId = this.deviceIdReportRepair;
        }
        if (this.moduleTypeKey + '' === '7') {
          webCreate = 0;
        }
        if (this.$refs.addFormExtend) {
          this.$refs.addFormExtend.validate().then((valiFormExtend) => {
            if (!(valiForm && valiFormExtend)) {
              this.submitLoading = false;
              return;
            } else {
              if (this.$refs.addFormExtend.addFormExtend.timeRange) {
                if (
                  this.$refs.addFormExtend.addFormExtend.timeRange[0] + '' ===
                  this.$refs.addFormExtend.addFormExtend.timeRange[1] + ''
                ) {
                  this.$message.error('开始时间和结束时间相同!');
                  this.submitLoading = false;
                  return;
                }
              }
              this.addForm.moduleJson = JSON.stringify({
                deviceId: deviceId,
                ...this.addFormExtend,
                webCreate: webCreate,
              });
              this.addForm.attachList = this.fileList;
              createOrderApi(this.addForm)
                .then((res) => {
                  if (res.success) {
                    this.$emit('success', res.data);
                    this.$message.success('操作成功！');
                  } else {
                    this.$message.error(res.msg);
                  }
                  this.deviceIdReportRepair = '';
                  this.dialogOrderCreateBoxVisible = false;
                  this.submitLoading = false;
                })
                .catch((err) => {
                  this.submitLoading = false;
                });
            }
          });
        } else {
          this.addForm.attachList = this.fileList;
          // 无拓展表的情况
          this.addForm.moduleJson = JSON.stringify({
            deviceId: deviceId,
            webCreate: webCreate,
          });
          createOrderApi(this.addForm)
            .then((res) => {
              if (res.success == true) {
                this.$emit('success', res.data);
                this.$message.success(res.msg);
              } else {
                this.$message.error(res.msg);
              }
              this.deviceIdReportRepair = '';
              this.dialogOrderCreateBoxVisible = false;
              this.submitLoading = false;
            })
            .catch((err) => {
              this.submitLoading = false;
            });
        }
      });
    },
    /* 关闭窗口 */
    handleClose(done) {
      let self = this;
      this.$confirm('确认关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.dialogOrderCreateBoxVisible = false;
        })
        .catch(() => {});
    },
    /* 切换项目 */
    changeHandler_(value) {
      this.projectId = value;
      this.addForm = Object.assign({}, this.addForm, {
        areaId: '',
        areaName: '',
        moduleType: '',
        subModuleId: '',
      });
      this.subModuleList = [];
      this.moduleTypeList = [];
      // 是否需要经纬度
      this.positionFlag = false;
      // 动态获取服务类型
      modulesSetting2(value).then((res) => {
        if (res.success) {
          this.moduleTypeList = res.data;
        }
      });
      lazyTree({
        parentId: 0,
        projectId: value,
      }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.treeFormAreaData = data;
      });
    },
    /* 切换服务类型 */
    orderModuleTpyeChange(val) {
      let projectId = this.deepClone(this.addForm.projectId);
      let source = this.deepClone(this.addForm.source);
      let moduleType = this.deepClone(this.addForm.moduleType);
      this.remainUserList = [];
      this.deptList_ = [];
      this.addForm = {
        projectId: projectId,
        source: source,
        moduleType: moduleType,
      };
      if (!this.addForm.projectId) {
        this.$message.error('请先选择项目!');
        return;
      }
      if (val == 7) {
        this.getFieldDetail(this.addForm.projectId, val, 0);
      } else {
        this.addFormRules['description'][0].required = true;
        this.formImgRequireFlag = false;
      }

      this.addForm = Object.assign({}, this.addForm, {
        subModuleId: '',
      });

      getRemarkList({
        projectId: this.addForm.projectId,
        moduleType: val,
        actionType: 0,
        workStatus: 0,
      }).then((res) => {
        this.$refs.addFormRemarkModel.setRemarkList(res.data);
      });

      getSubModuleListByOrderFlag({
        moduleType: this.addForm.moduleType,
        projectId: this.addForm.projectId,
      }).then((res) => {
        this.subModuleList = Object.assign({}, {}, res.data);
        this.subModuleList = this.deepClone(this.subModuleList);
        this.addForm = Object.assign({}, this.addForm, {});
      });
      // 动态组件 val:1 ===> this.choosenModuleName:'Clean'
      this.moduleTypeKey = val;
      this.choosenModuleName = modulesConfig[val];
      this.addFormExtend = {};
      // 查询是否需要经纬度
      settingPositionflag({
        projectId: this.addForm.projectId,
        moduleType: this.addForm.moduleType,
      }).then((res) => {
        this.positionFlag = res.data;
        let positionLongitude = this.findObject(
          this.addOrderFormOption.column,
          'positionLongitude'
        );
        let positionLatitude = this.findObject(this.addOrderFormOption.column, 'positionLatitude');
        if (this.positionFlag) {
          positionLongitude.display = true;
          positionLatitude.display = true;
        } else {
          positionLongitude.display = false;
          positionLatitude.display = false;
        }
      });
    },
    /* 切换子类型 */
    orderSubModuleIdChange(val) {
      getRemarkList({
        projectId: this.addForm.projectId,
        moduleType: this.addForm.moduleType,
        actionType: 0,
        subModuleId: val,
        workStatus: 0,
      }).then((res) => {
        this.$refs.addFormRemarkModel.setRemarkList(res.data);
      });
    },
    /* 获取字段填写修饰 */
    async getFieldDetail(projectId, moduleType, actionType) {
      let obj = {
        projectId: projectId,
        moduleType: moduleType,
        actionType: actionType,
      };
      await fieldDetail(obj).then((res) => {
        let description, uploadFile;
        res.data.forEach((item) => {
          if (item.fieldCode == 'uploadFile') {
            uploadFile = item;
          }
          if (item.fieldCode == 'description') {
            description = item;
          }
        });
        if (description) {
          if (description.defaultMustFlag == 0) {
            this.addFormRules['description'][0].required = false;
          } else {
            this.addFormRules['description'][0].required = true;
          }
        }
        if (uploadFile) {
          if (uploadFile.defaultMustFlag == 0) {
            this.formImgRequireFlag = false;
          } else {
            this.formImgRequireFlag = true;
          }
        }
      });
    },
    /* 获取区域树 */
    editAreaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      lazyAreaTree({
        parentId: id,
        projectId: this.projectId,
      }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        } else {
        }
        resolve(data);
      });
    },
    /* 点击区域树 */
    editAreaNodeTreeClick_(node) {
      setTimeout(() => {
        if (parseInt(node.nodeType) == 1) {
          return;
        }
        let nodeId = node.id;
        let nodeTitle = node.name;
        this.addForm = Object.assign({}, this.addForm, {
          areaName: nodeTitle,
          areaId: nodeId,
        });
        this.$refs.addConnectSelect.blur();
        this.areaNameFlag = true;
        this.areaIdFlag = false;
        getDeptDetailByAreaId({
          areaId: nodeId,
        }).then((res) => {
          getDeptUserListByDeptId({
            deptId: res.data.id,
          }).then((response) => {
            response.data.forEach((element) => {
              element.label = element.realNameAndPhone;
              element.value = element.id;
            });
            setTimeout(() => {
              let hasDefaultMan = false;
              this.requireUserList = response.data;
              this.requireUserList.forEach((ele, index) => {
                if (ele.id === this.addForm.requireMainId) {
                  hasDefaultMan = false;
                }
              });
              if (this.requireUserList && this.requireUserList.length == 0) {
                hasDefaultMan = true;
              }
              let self = this;
              if (hasDefaultMan) {
                this.requireUserList = [
                  {
                    value: self.userInfo.user_id,
                    label: self.userInfo.nick_name,
                    id: self.userInfo.user_id,
                    realNameAndPhone: self.userInfo.nick_name,
                  },
                ];
              }
              this.addForm = Object.assign({}, this.addForm, {
                deptId: res.data.id,
                requireDeptName: res.data.deptName,
              });
            });
          });
        });
      }, 0);
    },
    /* 需求人 */
    peopleChange(val) {
      if (!val) {
        this.addForm = Object.assign({}, this.addForm, {
          deptId: '',
          requireDeptName: '',
        });
        return;
      }
      this.getDeptNameByUserIdFunc(this.addForm.requireMainId).then((res) => {
        this.deptList_ = res.data;
        this.addForm = Object.assign({}, this.addForm, {
          deptId: res.data[0].deptId,
          requireDeptName: res.data[0].deptName,
        });
      });
    },
    getDeptNameByUserIdFunc(id) {
      return getDeptNameByUserId({
        id: id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  width: 100%;
  margin-left: 0 !important;
}
::v-deep .el-form-item--small {
  width: 100%;
  display: flex;
}
::v-deep .el-form-item {
  width: 100%;
  display: flex;
}
::v-deep .el-form-item__label {
  width: 100%;
}
::v-deep .el-textarea__inner {
  height: 5rem !important;
}
</style>
